//NOTE:::USER METADATA
export const USER_METADATA_DEFAULT_DATA = "USER_METADATA_DEFAULT_DATA";
export const USER_METADATA_SET_METADATA = "USER_METADATA_SET_METADATA";
export const USER_METADATA_UPDATE_LAST_ACTIVE_ROLE = "USER_METADATA_UPDATE_LAST_ACTIVE_ROLE";

//NOTE:::COMPANY METADATA
export const SET_COMPANY_DATA = "SET_COMPANY_DATA";
export const SET_COMPANIES_LIST = "SET_COMPANIES_LIST";
//NOTE:::GLOBAL LOADING
export const SET_GLOBAL_LOADING = "SET_GLOBAL_LOADING";

//NOTE:::BANK CARDS
export const SET_BANK_CARDS = "SET_BANK_CARDS";

//NOTE:::SALSA
export const SET_SALSA = "SET_SALSA";

//NOTE:::WORKER KYC ONBOARDING
export const SET_WORKER_KYC_ONBOARDING_IN_PROGRESS = "SET_WORKER_KYC_ONBOARDING_IN_PROGRESS";

//NOTE:::USER REQUEST IN ROUTE
export const SET_ROUTER_USER_REQUEST_IN_PROGRESS = "SET_ROUTER_USER_REQUEST_IN_PROGRESS";

//NOTE:::USER'S REWARD POINTS
export const SET_USER_REWARD_POINTS = "SET_USER_REWARD_POINTS";

//NOTE:::SUBSCRIPTION PRICES
export const SET_SUBSCRIPTION_PRICES = "SET_SUBSCRIPTION_PRICES";
